import { render } from "./x4_drink_the_air.vue?vue&type=template&id=01dec60f&scoped=true"
import script from "./x4_drink_the_air.vue?vue&type=script&lang=js"
export * from "./x4_drink_the_air.vue?vue&type=script&lang=js"

import "./x4_drink_the_air.vue?vue&type=style&index=0&id=01dec60f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01dec60f"]])

export default __exports__